type Timeout = number;

// returning 'null 'indicates no more backoffs
type BackOffStrategy = (numErrors: number) => Timeout | null;

// magic numbers
const quickAttempts = 4;
const exponent = 1.4;
const totalAttempts = 20;

function exponentialBackoff(maxAttempts: number): BackOffStrategy {
  return (numErrors: number) => {
    if (numErrors > maxAttempts) {
      return null;
    } else if (numErrors <= quickAttempts) {
      return 1000; // 1 second
    } else {
      return Math.pow(Math.max(numErrors - quickAttempts, 1), exponent) * 1000;
    }
  };
}

export const backoffDelayForAttempt = exponentialBackoff(totalAttempts);
